import React, { useState } from "react";
import { Button, Collapse, Form, Input, Tag } from "antd";
import PlanCollapse from "./PlanCollapse";
import PlanCollapseUnit from "./PlanCollapseUnit";
import PlanCollapseOrg from "./PlanCollapseOrg";

const { Panel } = Collapse;

function Plans() {
  const [addKpi, setAddKpi] = useState(false);

  return (
    <div className="pb-8">
      <div className="text-base pri-font mb-3">Your plans</div>
      <PlanCollapse />

      <div className="text-base pri-font mb-3 mt-6">Unit plans</div>
      <PlanCollapseUnit />

      <div className="text-base pri-font mb-3 mt-6">Organizational plans</div>
      <PlanCollapseOrg />
    </div>
  );
}

export default Plans;
